export default "__VITE_PUBLIC_ASSET__cedd10a7__"